import { useState, useEffect } from "react";
import { SiteHeader } from "../../components/header/header";
import classNames from "classnames";

import { carsData } from "../../mock-data/car-data";
import { ItemCard } from "../../components/cards/item-card";
import { OurQualities } from "../../components/containers/qualities";
import { SiteFooter } from "../../components/footer/footer";
import { UseCarContext } from "../../services/products/product.context";
import { NavComponent } from "../../components/header/nav-component";
import { UseCartList } from "../../services/cart/cart.context";
import { CartComponent } from "../saved/cart";
import { searchProduct } from "../../_helpers/search";
import { CarsFilter } from "../../components/utilities/filter-component";

export const Catalog = () => {

    const [openNav, setOpenNav] = useState(false);
    const [cartItem, setCartItem] = useState();

    const { someCars } = UseCarContext();
    const { saveToWishList, wishList, toggleCart, openCart } = UseCartList();

     const [searchFor, setSearchFor] = useState('All');
        const [pageCars, setPageCars] = useState(someCars);
       
    const handleFilter = (v) => {
           const resultsArray = searchProduct(v, someCars);
           setPageCars(resultsArray);
        }
    
        useEffect(() => {
            setPageCars(someCars);
        }, [someCars])
    

    const togglenavOpen = () => setOpenNav((st) => !st);

    return (
        <div className="f-pg app-pg">
            <SiteHeader togglenavOpen={togglenavOpen} />
            <CartComponent
                inView={openCart}
                itemdata={cartItem}
                resetCart={() => setCartItem()}
            />

            <div className="flx-rw filters">
                <CarsFilter setFilter={(v) => {
                    setSearchFor(v);
                    handleFilter(v);
                }} />
                <div className="filter-label">
                    {searchFor} Cars
                </div>
            </div>
            <div className="car-list">
                {pageCars?.map((car) => (
                    <ItemCard
                        item={car}
                        openCart={() => {
                            toggleCart();
                            setCartItem(car);
                        }}
                        wishList={wishList}
                        addToList={() => saveToWishList(car)}
                    />
                ))}
            </div>
            <OurQualities />
            <SiteFooter />
        </div>
    )
}